import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import ProtectedRoute from "./components/ProtectedRoute";
import AdsProtectedRoute from "./components/AdsProtectedRoute";
import CreateScheme from "./pages/schemes/CreateScheme";
import AuditLogs from "./pages/AuditLogs";
import AdsLogin from "./pages/ads/AdsLogin";
import AdsSignup from "./pages/ads/AdsSignup";
import AdsDashboard from "./pages/ads/AdsDashboard";
import LandingPage from "./pages/LandingPage";

const AdsRootRedirect = () => {
  const adToken = typeof window !== "undefined" ? localStorage.getItem("adToken") : null;
  return <Navigate to={adToken ? "/ads/dashboard" : "/ads/login"} replace />;
};

const AdminLoginEntry = () => {
  const token = typeof window !== "undefined" ? localStorage.getItem("token") : null;
  return token ? <Navigate to="/dashboard" replace /> : <Login />;
};

const App = () => {
  return (
    <Router>
      <Routes>
        {/* Public routes */}
        <Route path="/" element={<LandingPage />} />
        <Route path="/login" element={<AdminLoginEntry />} />

        {/* Ads module: separate signup, login, and dashboard */}
        <Route path="/ads" element={<AdsRootRedirect />} />
        <Route path="/ads/signup" element={<AdsSignup />} />
        <Route path="/ads/login" element={<AdsLogin />} />
        <Route
          path="/ads/dashboard/*"
          element={
            <AdsProtectedRoute>
              <AdsDashboard />
            </AdsProtectedRoute>
          }
        />

        {/* Protected routes (admin) */}
        <Route
          path="/dashboard/*"
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          }
        />

        <Route path="/create_scheme" element={<CreateScheme />} />
        <Route path="/audit-logs" element={
          <ProtectedRoute>
            <AuditLogs />
          </ProtectedRoute>
        } />

        {/* Catch all route - redirect to login */}
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    </Router>
  );
};

export default App;
